import { Link } from "react-router-dom";
import { Seo } from "@/components/site/Seo";
import { HomeHero } from "@/components/home/HomeHero";
import { SeasonalBanner } from "@/components/home/SeasonalBanner";
import { HomeIntro } from "@/components/home/HomeIntro";
import { ServicesBento } from "@/components/home/ServicesBento";
import { WhySnapshot } from "@/components/home/WhySnapshot";
import { ProjectPreview } from "@/components/home/ProjectPreview";
import { Marquee } from "@/components/site/Marquee";
import { CtaBanner } from "@/components/site/CtaBanner";
import { SectionHeading, Reveal } from "@/components/site/Reveal";
import { PlaceholderNotice, ReviewCard } from "@/components/site/ReviewBits";
import { SERVICES } from "@/lib/site";

const ReviewsTeaser = () => (
  <section className="bg-[var(--grey)] py-20 md:py-28" data-testid="home-reviews">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <div className="grid gap-8 md:grid-cols-12 md:items-end mb-10">
        <SectionHeading className="md:col-span-8" eyebrow="Customer reviews" title="What our customers say." />
        <Reveal delay={0.1} className="md:col-span-4 md:text-right">
          <Link to="/reviews" data-testid="home-reviews-link" className="link-underline font-semibold text-[var(--navy)]">All reviews →</Link>
        </Reveal>
      </div>
      <Reveal className="mb-8"><PlaceholderNotice /></Reveal>
      <div className="grid gap-5 md:grid-cols-3">
        {SERVICES.map((s, i) => <ReviewCard key={s.slug} n={i + 1} category={s.title} delay={i * 0.08} />)}
      </div>
    </div>
  </section>
);

export default function Home() {
  return (
    <>
      <Seo
        title="Handyman Services Oxfordshire | Easy Handyman Services"
        description="Handyman services in Oxfordshire: interior painting and home improvements, garden maintenance, deep cleaning and carpet cleaning. Request your free quote today."
      />
      <HomeHero />
      <SeasonalBanner />
      <Marquee />
      <HomeIntro />
      <ServicesBento />
      <WhySnapshot />
      <ProjectPreview />
      <ReviewsTeaser />
      <CtaBanner />
    </>
  );
}
